module.exports = __webpack_public_path__ + "img/C535.1aeec689.jpg";